'use strict';

customerZone.controller('NotificationSettingsController', ['$q', '$log', 'utils', 'Session', 'SettingsService',
    function($q, $log, utils, Session, settingsService){

        var self = this;

        var settings = [];
        self.loading = false;
        self.subscriber = Session.subscriber();
        self.subscribers = Session.subscribers();

        var loadSettings = function(){
            return settingsService.getNotificationSettings()
                .then(function(_settings_){
                    settings = _settings_;
                });
        };

        Object.defineProperty(self, 'generalSettings', {
            get: function(){ return settings['_']; }
        });

        Object.defineProperty(self, 'subscriptionSettings', {
            get: function(){
                return self.subscriber ? settings[self.subscriber.msisdn] : [];
            }
        });

        self.saveSettings = function(){
            var savePromise = settingsService.saveNotificationSettings(settings);
            var busy = utils.showBusy(savePromise, 'update_pending', 'update_complete');
            return busy.wrappedPromise;
        };

        var init = function(){
            self.loading = utils.translate('loading_data');
            loadSettings()
                .then(function(){
                    self.loading=false;
                }, function(error){
                    $log.error('could not load settings:', error);
                    utils.showError();
                });
        };

        self.labelFor = function(setting){
            return utils.translate('notification_setting_'+setting.name);
        };

        self.hasSubscriptionSettings = function(){
            for (var i=0; i<self.subscribers.length; i++)
                if (settings[self.subscribers[i].msisdn] && settings[self.subscribers[i].msisdn].length > 0)
                    return true;
            return false;
        };

        init();
    }]);

